import { api } from './api';

export interface Usuario {
  id: string;
  idRole?: string;
  idFuncionario?: number;
  nomeFuncionario?: string;
  usuario: string;
  userName?: string;
  senha?: string;
  role?: string;
  idIdentityRole?: string;
}

export interface UsuarioRequest {
  id?: string;
  idFuncionario: number;
  usuario: string;
  senha: string;
  idIdentityRole: string;
}

export const usuarioService = {
  // Buscar todos os usuários
  getAllUsers: async (): Promise<Usuario[]> => {
    const response = await api.get<Usuario[]>('/api/Usuario/GetAllUsers');
    return response.data;
  },

  // Buscar usuário por ID
  getById: async (id: string): Promise<Usuario> => {
    const response = await api.get<Usuario>(`/api/Usuario/GetById?id=${id}`);
    return response.data;
  },

  // Salvar usuário (novo ou edição)
  save: async (usuario: UsuarioRequest): Promise<Usuario> => {
    const response = await api.post<Usuario>('/api/Usuario/Salvar', usuario);
    return response.data;
  },
};
